module.exports = "/fonts/nucleo-icons.woff2?cba267483aa6a7cb6e337fd2a2044777";